<template>
  <div
    :class="['app-multiselect__search-container', { '--focus': isFocus }]"
    @click="redirectFocusToInput"
  >
    <SearchIcon class="app-multiselect__search-icon" />
    <input
      type="text"
      class="app-multiselect__search-input"
      :placeholder="multiselectRef._props.searchPlaceholder"
      v-model="searchInput"
      ref="searchInputRef"
      @input="searchInArray()"
      @focus="isFocus = true"
      @blur="isFocus = false"
    />
  </div>
</template>

<script>
  import SearchIcon from './icons/SearchIcon.vue';

  export default {
    components: {
      SearchIcon
    },
    methods: {
      normalizeString(str) {
        return str
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();
      },
      searchInArray() {
        const normalizedSearchText = this.normalizeString(this.searchInput);

        this.multiselectRef._data.datalistFiltered = this.multiselectRef._props.datalist.filter(
          (item) => this.normalizeString(item.text).includes(normalizedSearchText)
        );
      },
      redirectFocusToInput() {
        this.$refs.searchInputRef.focus();
      }
    },
    props: {
      multiselectRef: {
        type: Object,
        default: () => {}
      }
    },
    data: () => ({
      searchInput: '',
      isFocus: false
    }),
    mounted() {
      this.$refs.searchInputRef.focus();
    },
    watch: {
      'multiselectRef._props.datalist'() {
        this.searchInput = '';
      }
    }
  };
</script>

<style lang="scss">
  .app-multiselect__container {
    .app-multiselect__search-container {
      display: flex;
      align-items: center;
      padding: 5px 13px;
      gap: 14px;
      border: 1px solid #cfc4be;
      border-radius: 4px;
      cursor: text;

      &.--focus {
        border-color: #974900 !important;
      }

      .app-multiselect__search-icon {
        width: 14px;
        height: 14px;

        path {
          fill: #cfc4be;
        }
      }

      .app-multiselect__search-input {
        flex: 1;
        border: 0;
        padding: 0;
        font-family: Raleway;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        outline: none;

        &::placeholder {
          color: #cfc4be;
        }
      }
    }
  }
</style>
